const mediaSeed = [
  {
    id: 'media-001',
    category: '교육기관',
    organization: '한빛진로교육원',
    title: '중학생을 위한 2027 진로 설계 설명회',
    description: '학생의 적성과 학습 데이터를 바탕으로 진로 방향을 설계하는 공개 설명회입니다.',
    publishedAt: '2026-08-28',
    views: 1840,
    duration: '12:48',
    theme: 'violet',
    featured: true,
    verified: true,
    tags: ['진로', '설명회', '중학생'],
  },
  {
    id: 'media-002',
    category: '사설기관(학원)',
    organization: '라온수학학원',
    title: '2학기 중간고사 수학, 지금 준비해야 하는 이유',
    description: '학교별 출제 경향과 4주 완성 학습 계획을 소개합니다.',
    publishedAt: '2026-08-27',
    views: 932,
    duration: '08:21',
    theme: 'blue',
    featured: true,
    verified: true,
    tags: ['수학', '중간고사', '학습전략'],
  },
  {
    id: 'media-003',
    category: '교육기관',
    organization: '미래코딩교육센터',
    title: 'AI 시대에 꼭 필요한 청소년 코딩 프로젝트',
    description: '문제 발견부터 결과 발표까지 진행하는 프로젝트형 수업을 만나보세요.',
    publishedAt: '2026-08-26',
    views: 2670,
    duration: '15:06',
    theme: 'navy',
    featured: true,
    verified: true,
    tags: ['코딩', '인공지능', '프로젝트'],
  },
  {
    id: 'media-004',
    category: '전문 개인강사',
    organization: '김서윤 영어연구소',
    title: '영어 서술형 점수를 올리는 문장 구조 훈련',
    description: '시험에서 바로 활용할 수 있는 문장 분석과 서술형 답안 작성법을 알려드립니다.',
    publishedAt: '2026-08-24',
    views: 754,
    duration: '10:35',
    theme: 'coral',
    featured: false,
    verified: true,
    tags: ['영어', '서술형', '내신'],
  },
  {
    id: 'media-005',
    category: '교재·출판',
    organization: '배움나무출판',
    title: '개념부터 유형까지 한 권으로 끝내는 중등 과학',
    description: '새 교육과정을 반영한 중등 과학 교재의 구성과 디지털 학습 연동 방법을 소개합니다.',
    publishedAt: '2026-08-22',
    views: 1214,
    duration: '06:44',
    theme: 'green',
    featured: false,
    verified: true,
    tags: ['교재', '과학', '신간'],
    targetUrl: '/storeBook',
  },
  {
    id: 'media-006',
    category: '교육자료',
    organization: '한국학습상담협회',
    title: '부모와 학생이 함께 만드는 주간 학습 계획',
    description: '지키기 쉬운 목표를 세우고 매주 점검하는 학습 계획표 활용법입니다.',
    publishedAt: '2026-08-20',
    views: 3480,
    duration: '09:17',
    theme: 'amber',
    featured: false,
    verified: true,
    tags: ['학습계획', '상담', '학부모'],
  },
  {
    id: 'media-007',
    category: '사설기관(학원)',
    organization: '아르떼미술학원',
    title: '청소년 창작 포트폴리오 수업 작품전',
    description: '관찰과 표현을 연결한 학생들의 창작 과정과 작품을 공개합니다.',
    publishedAt: '2026-08-18',
    views: 621,
    duration: '04:52',
    theme: 'pink',
    featured: false,
    verified: false,
    tags: ['미술', '포트폴리오', '작품전'],
  },
  {
    id: 'media-008',
    category: '전문 개인강사',
    organization: '박지훈 역사교실',
    title: '사진 한 장으로 이해하는 근현대사 핵심 장면',
    description: '사료와 사진을 연결해 근현대사의 흐름을 쉽고 정확하게 설명합니다.',
    publishedAt: '2026-08-16',
    views: 1088,
    duration: '11:29',
    theme: 'brown',
    featured: false,
    verified: false,
    tags: ['역사', '근현대사', '한국사'],
  },
];

export const mediaCategories = [
  '전체',
  '교육기관',
  '사설기관(학원)',
  '전문 개인강사',
  '교재·출판',
  '교육자료',
];

export default mediaSeed;
